import { render, staticRenderFns } from "./Lottery_Coming_Card.vue?vue&type=template&id=57c4a4b3&scoped=true"
import script from "./Lottery_Coming_Card.vue?vue&type=script&lang=js"
export * from "./Lottery_Coming_Card.vue?vue&type=script&lang=js"
import style0 from "./Lottery_Coming_Card.vue?vue&type=style&index=0&id=57c4a4b3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c4a4b3",
  null
  
)

export default component.exports